import React from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  image?: string;
}

export function SEO({ title, description, canonical, image }: SEOProps) {
  const siteTitle = 'MemPalace - 智能记忆管理系统';
  const siteDescription = '基于 Cloudflare 构建的简单记忆管理工具，帮你更好地记住重要的事情。';
  const url = canonical || 'https://mempalace.pages.dev';
  const socialImage = image || '/images/social-preview.jpg';

  // 在浏览器中手动设置 meta 标签
  React.useEffect(() => {
    // 标题
    document.title = title ? `${title} | ${siteTitle}` : siteTitle;
    
    // 描述
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || siteDescription);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description || siteDescription;
      document.head.appendChild(meta);
    }
    
    // Open Graph
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const ogImage = document.querySelector('meta[property="og:image"]');
    
    if (ogTitle) ogTitle.setAttribute('content', title || siteTitle);
    if (ogDescription) ogDescription.setAttribute('content', description || siteDescription);
    if (ogUrl) ogUrl.setAttribute('content', url);
    if (ogImage) ogImage.setAttribute('content', socialImage);
    
    // Twitter Card
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    
    if (twitterTitle) twitterTitle.setAttribute('content', title || siteTitle);
    if (twitterDescription) twitterDescription.setAttribute('content', description || siteDescription);
  }, [title, description, url, socialImage, siteTitle, siteDescription]);

  return null; // 这个组件不渲染任何内容
}
